import React from 'react';
import IconRightArrow from './Icons/IconRightArrow';
import IconLeftArrow from './Icons/IconLeftArrow';
import styled from 'styled-components';

const PaginationContainer = styled.nav`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;

    .pagination-list {
        display: flex;
        align-items: center;
        gap: 4px;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .pagination-item {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .pagination-button {
        min-width: 32px;
        height: 32px;
        padding: 0 8px;
        border: 1px solid #CBC1B7;
        background-color: rgba(255, 255, 255, 0.4);
        color: #184353;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        font-size: 12px;
        font-weight: 500;
        font-family: 'Poppins', sans-serif;
        transition: all 0.2s;
        
        &.prev-button {
            padding-right: 12px;
        }
        
        &.next-button {
            padding-left: 12px;
        }

        &:hover:not(:disabled) {
            background-color: #ffffff;
            border-color: #FF5F39;
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            
            &.active {
                opacity: 1; // Full opacity for active page even when disabled
            }
        }

        &.active {
            background-color: #184353;
            color: white;
            border-color: #184353;
        }
    }

    .pagination-button-text {
        font-size: 12px;
    }
    
    .pagination-button svg {
        display: inline-block;
        vertical-align: baseline;
        flex-shrink: 0;
        margin-bottom: 2px;
    }
`;

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage, totalItems }) => {
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages && page !== currentPage) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);

        if (endPage - startPage < maxVisible - 1) {
            startPage = Math.max(1, endPage - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <li key={i} className="pagination-item">
                    <button
                        className={`pagination-button ${i === currentPage ? 'active' : ''}`}
                        onClick={() => handlePageChange(i)}
                        disabled={i === currentPage}
                    >
                        {i}
                    </button>
                </li>
            );
        }

        return pages;
    };

    if (totalPages <= 1) {
        return null;
    }

    return (
        <PaginationContainer>
            <ul className="pagination-list">
                {currentPage > 1 && (
                    <li className="pagination-item">
                        <button
                            className="pagination-button prev-button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            aria-label="Go to previous page"
                        >
                            <IconLeftArrow />
                            <span className="pagination-button-text">Previous</span>
                        </button>
                    </li>
                )}
                {renderPageNumbers()}
                {currentPage < totalPages && (
                    <li className="pagination-item">
                        <button
                            className="pagination-button next-button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Go to next page"
                        >
                            <span className="pagination-button-text">Next</span>
                            <IconRightArrow />
                        </button>
                    </li>
                )}
            </ul>
        </PaginationContainer>
    );
};

export default Pagination;

